import {AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, TemplateRef, ViewChild} from "@angular/core";
import {AbstractListView} from "../../../core/visbos-core/ui/components/abstract-list-view";
import {DatatableComponent} from "../../../core/visbos-core/ui/components/datatable/datatable.component";
import {FormBuilder} from "@angular/forms";
import {SessionActions} from "../../../shared/actions/session.actions";
import {MedicineBookEntry} from "../../model/medicine-book-entry";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";

@Component({
  selector: 'vb-medicine-book-entries-table',
  templateUrl: './medicine-book-entries-table.component.html',
  styleUrls: ['./medicine-book-entries-table.component.css']
})
export class MedicineBookEntriesTableComponent extends AbstractListView implements OnInit, AfterViewInit {

  private _medicineBookEntries: MedicineBookEntry[] = [];

  get medicineBookEntries(): MedicineBookEntry[] {
    return this._medicineBookEntries;
  }

  @Input()
  set medicineBookEntries(value: MedicineBookEntry[]) {
    this._medicineBookEntries = value;
    this.rows = value ? value : [];
  }

  onCellUpdate(row, res, index) {
  }

  @ViewChild('reasonTmpl')
  reasonTmpl: TemplateRef<any>;

  @ViewChild('userTmpl')
  userTmpl: TemplateRef<any>;

  @ViewChild('entries')
  table: DatatableComponent;

  messages = {
    emptyMessage: 'Keine Einträge im Verbrauchsbuch',
    totalMessage: 'Einträge im Verbrauchsbuch insgesamt'
  };

  constructor(private fb: FormBuilder, sessionActions: SessionActions, cd: ChangeDetectorRef) {
    super(sessionActions, cd);
  }

  ngOnInit() {

    this.searchTerm = this.fb.control(null);
    this.dataSubscriptions.push(
      this.searchTerm.valueChanges.pipe(
        distinctUntilChanged(),
        debounceTime(500)
      ).subscribe((term: any) => this.filterItems(term))
    );

    this.columns = [
      {prop: 'entry_date', name: 'Datum', cellTemplate: this.table.formatDateTmpl, sortable: false, flexGrow: 1},
      {prop: 'type', name: 'Art', sortable: false, flexGrow: 1},
      {prop: 'old_stock', name: 'Bestand', sortable: false, flexGrow: 1},
      {prop: 'stock_change', name: 'Zu-/Abgang', sortable: false, flexGrow: 1},
      {prop: 'new_stock', name: 'Neuer Bestand', sortable: false, flexGrow: 1},
      {name: 'Änderungsgrund', cellTemplate: this.reasonTmpl, sortable: false, flexGrow: 3},
      {name: 'Name', cellTemplate: this.userTmpl, sortable: false, flexGrow: 3},
    ];

  }


  filterItems(searchTerm) {
    if (!searchTerm || searchTerm == "") {
      this.rows = this._medicineBookEntries;
    } else {
      if (this._medicineBookEntries) {
        this.rows = this._medicineBookEntries.filter((si: any) => this.findStringInTable(si, this.columns, searchTerm));
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/medicine/medicine-book-entries-table/medicine-book-entries-table.component.ts